<div id="sharedSigningModal" class="modal fade" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-xl modal-lg modal-md" style="width: 80% !important;">
    <div class="modal-content">
      <div class="modal-header bg-primary-400">
        <button type="button" class="close" (click)="onTimesIconPressed()">&times;</button>
        <h6 class="modal-title">{{translate.instant("Shared Signing Settings")}}</h6>
      </div>
      <div class="modal-body">
        <div class="panel panel-flat shadow" style="border: none">
          <div class="panel-body">
            <div class="row">
              <div class="col-sm-12">
                <div class="col-sm-12">
                  <div class="panel panel-warning" [hidden]="sendNotification == null">
                    <div class="panel-body">
                      <div class="row">
                        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8">
                          <label>{{translate.instant("Send a warning to people who didn't sign after enough signatures have been collected.")}}</label> 
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                          <label class="switch">
                            <input type="checkbox" (click)="onSendNotificationClicked()" [checked]="sendNotification">
                            <span class="slider round"></span>
                          </label>
                        </div>
                      </div>
                      <hr>
                      <div class="row">
                        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8">
                          <label>{{translate.instant("After a sufficient amount of signatures is collected, close the document for signature and end the process. Duration (in hours): ")}}</label>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                          <label><input type="number" [value]="sendNotificationTime" style="width:50px" min="0" (input)="onSendNotificationTimeChanged($event)"></label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 hide-on-laptop" *ngFor="let user of testUser; let i = index">
                  <div class="panel panel-warning">
                    <div class="panel-body">
                      <table class="table table-md table-sm table-xs table-condensed table-borderless text-center">
                        <tbody>
                          <tr>
                            <td class="col-lg-1 col-md-1 col-sm-1 col-xs-1" style="border-right: solid 1px lightgrey; padding-right: 10px" style="text-align: left;">
                              <h1><strong>{{user.order}}</strong></h1>
                            </td>
                            <td class="col-lg-8 col-md-8 col-sm-8 col-xs-8">
                              <div class="row">
                                <div class="col-md-12">
                                  <div style="margin-left:-45%;">
                                    <label style="font-size: 15px;font-weight: bold;margin-bottom: 0px !important;">
                                      {{translate.instant("Required share for decision:")}}
                                      <input type="number" [value]="user.totalShare" min="1" (input)="onChangeTotalShare(i,$event)" [hidden]="user.checkbox" style="width: 50px;" [disabled]="user.checkbox" id="group_share_{{i}}">
                                      <input type="checkbox" style="margin-left:10px" (click)="onCheckboxClicked(i);" [checked]="user.checkbox" id="group_checkbox_{{i}}" > {{" "+translate.instant("Unanimity")}}
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <table class="table table-md table-sm table-condensed table-borderless text-left">
                                <tbody>
                                  <tr>
                                    <th class="col-lg-4 col-md-4 col-sm-4 col-xs-4"><u>{{translate.instant("Name Surname")}}</u></th>
                                    <th class="col-lg-5 col-md-5 col-sm-5 col-xs-5"><u>{{translate.instant("E-mail Address")}}</u></th>
                                    <th class="col-lg-3 col-md-3 col-sm-3 col-xs-3"><u>{{translate.instant("Decision Share")}}</u></th>
                                  </tr>
                                  <tr *ngFor="let j of getGroupUser(i); let userIndex = index" [style.backgroundColor]="j.color">
                                    <td class="col-lg-4 col-md-4 col-sm-4 col-xs-4 wrapword">{{j.name}}</td>
                                    <td class="col-lg-5 col-md-5 col-sm-5 col-xs-5 wrapword"><span>{{" " + j.email}}</span></td>
                                    <td class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                      <input type="number" style="width: 60px;" min="1" (input)="onChangeUserShare(i,userIndex,$event)" [value]="j.share">
                                    </td>
                                  </tr>
                                  <br>
                                </tbody>
                              </table>
                            </td>
                            <td class="col-lg-3 col-md-3 col-sm-3 col-xs-3" style="border-right: solid 1px lightgrey; padding-right: 10px">
                              <div *ngIf="!this.chartLoading" class="loader"></div>
                              <canvas #myCanvasChart width="0" height="0"></canvas>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 hide-on-desktop" *ngFor="let user of testUser; let i = index">
                  <div class="panel panel-warning">
                    <table class="table table-md table-sm table-xs table-condensed table-borderless text-center" style="text-align: left;">
                      <tbody>
                        <tr>
                          <td class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div class="row">
                              <div class="col-md-12">
                                <label style="font-size: 15px;font-weight: bold;margin-bottom: 0px !important;">
                                  {{translate.instant("Required share for decision:")}}
                                  <input type="number" [value]="user.totalShare" min="1" (input)="onChangeTotalShare(i,$event)" [hidden]="user.checkbox" style="width: 50px;" [disabled]="user.checkbox" id="group_share_{{i}}">
                                  <input type="checkbox" style="margin-left:10px" (click)="onCheckboxClicked(i);" [checked]="user.checkbox" id="group_checkbox_{{i}}" > {{" "+translate.instant("Unanimity")}}
                                </label>
                              </div>
                            </div>
                            <div class="row" style="text-align: left;">
                              <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5"><u>{{translate.instant("Name Surname")}}</u></div>
                              <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5"><u>{{translate.instant("E-mail Address")}}</u></div>
                              <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2"><u>{{translate.instant("Decision Share")}}</u></div>
                              <br>
                              <br>
                              <div *ngFor="let j of getGroupUser(i); let userIndex = index" [style.backgroundColor]="j.color">
                                <div class="row" style="padding: 5px;">
                                  <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5 wrapword">{{j.name}}</div>
                                  <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5 wrapword">{{j.email}}</div>
                                  <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                    <input type="number" style="width: 60px;" min="1" (input)="onChangeUserShare(i,userIndex,$event)" [value]="j.share">
                                  </div>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" type="button" (click)="onCancelButtonPressed()" translate>Cancel</button>
        <button class="btn btn-primary" type="button" (click)="onDoneButtonPressed()" translate>Done</button>
      </div>
    </div>
  </div>
</div>